import { render, staticRenderFns } from "./Embassy.vue?vue&type=template&id=219693ab"
import script from "./Embassy.vue?vue&type=script&lang=js"
export * from "./Embassy.vue?vue&type=script&lang=js"
import style0 from "./Embassy.vue?vue&type=style&index=0&id=219693ab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports